import * as helper from "@/store/helpers";
import { defineStore } from 'pinia'
import { useAuthStore } from '@/store/auth'

let default_user = {
    id: 0,
    email: '',
    profile_pic: {},
    surname: '',
    name: '',
    patronymic: '',
    job_title: '',
    regional_office: '',
    main_workplace: '',
    job_title_of_main_workplace: '',
    area_of_scientific_interests: '',
    scientific_achievements: '',
    significant_research: '',
    show_personality: false,
    allow_comments: false,
    main_publications: [],
    media_publications: []
}

export const useUserStore = defineStore('user', {
    state(){
        return {
            user: {...default_user},
            changeUser: {...default_user},
            personalitiesList: [],
            changeUserMsg: ''
        }
    },
    getters: {
        get_area_of_scientific_interests(state){
            return state.user.area_of_scientific_interests
        },
        get_scientific_achievements(state){
            return state.user.scientific_achievements
        },
        get_significant_research(state){
            return state.user.significant_research
        },
        get_media_publications(state){
            return state.user.media_publications
        },
        get_letters(state){
            return state.personalitiesList.map((per) => per.letter.toUpperCase())
        },
        get_personalities_list(state){
            return state.personalitiesList
        },
        get_change_user_msg(state){
            return state.changeUserMsg
        }
    },
    actions: {
        async getUser(id) {
            let user = await helper.api('GET','/public_users/'+id.toString(), {}, {})
            if (user){
              let new_user = {
                  id: user.id,
                  profile_pic: user.profile_pic,
                  email: user.email,
                  surname: user.surname,
                  name: user.name,
                  patronymic: user.patronymic,
                  job_title: user.job_title,
                  regional_office: user.regional_office,
                  main_workplace: user.main_workplace,
                  job_title_of_main_workplace: user.job_title_of_main_workplace,
                  area_of_scientific_interests: user.area_of_scientific_interests,
                  scientific_achievements: user.scientific_achievements,
                  significant_research: user.significant_research,
                  show_personality: user.show_personality,
                  allow_comments: user.allow_comments,
                  main_publications: user.main_publications,
                  media_publications: user.media_publications,
                  region_id: user.region_id}
              this.user = new_user
              this.changeUser = new_user
            }
            else{
                this.user = {}
                this.changeUser = {}
            }
        },
        async updateUser(){
            this.changeUserMsg = ''
            let changeUser = {}
            changeUser['id'] = this.changeUser.id
            changeUser['surname'] = this.changeUser.surname
            changeUser['profile_pic'] = this.changeUser.profile_pic
            changeUser['name'] = this.changeUser.name
            changeUser['patronymic'] = this.changeUser.patronymic
            changeUser['main_publications'] = this.changeUser.main_publications
            changeUser['media_publications'] = this.changeUser.media_publications
            changeUser['job_title'] = this.changeUser.job_title
            changeUser['regional_office'] = this.changeUser.regional_office
            changeUser['main_workplace'] = this.changeUser.main_workplace
            changeUser['job_title_of_main_workplace'] = this.changeUser.job_title_of_main_workplace
            changeUser['area_of_scientific_interests'] = this.changeUser.area_of_scientific_interests
            changeUser['scientific_achievements'] = this.changeUser.scientific_achievements
            changeUser['significant_research'] = this.changeUser.significant_research
            changeUser['region_id'] = this.changeUser.region_id
            changeUser['show_personality'] = this.changeUser.show_personality
            changeUser['allow_comments'] = this.changeUser.allow_comments
            console.log("changeUser")
            console.log(changeUser)
            this.changeUserMsg = await helper.api('POST','/public_users/update_user', changeUser)
        },
        async getPersonalitiesList(region_code, search_string){
            let permissions = useAuthStore().permissions
            let show_all = permissions.indexOf("personalities") > 0
            console.log({ 
                'show_all': show_all,
                'region_code': region_code,
                'search_string': search_string
            })
            let _search_string = search_string
            if (!search_string){
                _search_string =""
            }
            let personalitiesList = await helper.api('POST','/public_users/personalities_list', { 
                'show_all': show_all,
                'region_code': region_code,
                'search_string': _search_string
            })
            if (personalitiesList){
                this.personalitiesList = personalitiesList
            }
        }
    }
})